import React from 'react';
import Modal from '../../../../../../Components/Modal/Modal';
import NCZIEditContactForm from './NCZIEditContactForm';
import { NCZIPatientContact } from '../../../../Interfaces/ncziPatientInformations';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	contactInformation?: NCZIPatientContact;
}

const NCZIEditContactModal: React.FC<Props> = props => {
	const { opened, onClose, contactInformation, patientIdentifier } = props;

	return (
		<Modal opened={opened} onClose={() => onClose(false)} fullScreen={false}>
			<Modal.Header title='base.shared.edit' />
			<Modal.Content>
				<NCZIEditContactForm
					onClose={onClose}
					contactInformation={contactInformation}
					patientIdentifier={patientIdentifier}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default NCZIEditContactModal;
